import axios from "axios"
import RestApiService from "./RestApiService"

const controller = "/devolucionItems"

const DevolucionItemsService = {
    registrar: async (request) => {
        return RestApiService.send(`${controller}/registrar`, request)
    },
    buscarEmpleadoxNombre: async (request) => {
        const { data } = await axios.post(`${controller}/buscarEmpleadoxNombre`, request)
        return data
    },
    buscar: async (devolucion_items) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            devolucion_items
        })
        return data
    },
    buscarDevolucionesxItems: async (request) => {
        const { data } = await axios.post(`${controller}/buscarDevolucionesxItems`, request)
        return data
    },
    obtener: async (devolucion_items) => {
        const { data } = await axios.post(`${controller}/obtener`, {
            devolucion_items
        })
        return data
    },
    eliminar: async (request) => {
        const { data } = await axios.post(`${controller}/eliminar`, request)
        return data
    },
}

export default DevolucionItemsService;

